<script setup>

import { STATE } from '@/Ship';
import { useProfileResources, useProfileComponents } from '@profile';

const {
	Documents,
	ProfileForm,
} = useProfileComponents();

const profile = useProfileResources('Profile');

STATE.REBOOT_TIMER = 22;
STATE.BLUR = false;
STATE.SHOW_DISCONNECT_ALERT = false;

</script>

<template>
    <main class="profile environment">
	    <router-link class="close-btn" v-bind:to="{ name: 'Trading', params: $route.params}">
		    <g-symbol name="close" width="26" height="26"/>
	    </router-link>

        <g-flex gap="20" justify="around" align="start">
            <profile-form/>
            <documents/>
        </g-flex>
    </main>
</template>

<style lang="scss" scoped>
.environment {
    padding-top: 5vw;
    position: relative;
    height: calc(100vh - var(--topbar-height, $topbar-height));
}

.close-btn {
    font-size: 0;
    top: 10px;
    right: 20px;
    position: absolute;

    svg {
        fill: var(--title-text-color, $title-text-color);
    }
}

.g-flex {
    flex-basis: 100%;
    padding: 2vw 3vw;
    border-radius: 19px;
    min-height: calc(100vh - var(--topbar-height, $topbar-height));
    background: radial-gradient(circle at 50% 170%, #000000, #000000 60%, var(--secondary, $secondary) 80%, #00000000 30%);
}

@media (min-width: 741px) {
    .g-caption {
        margin-left: 3vw;
    }
}

@media (max-width: 740px) {
    .g-caption {
        text-align: center;
    }

    .g-flex {
        flex-wrap: wrap;
    }
}
</style>
